
// theme constant
export const gridSpacing = 3;
export const drawerWidth = 260;
export const appDrawerWidth = 320;

// import { Apicalls } from '../Axios/ServiceApi';

// console.log("url", url);


//
// export const AgentAddress = (data) => {
//   return (dispatch) =>
//     new Promise((resolve, reject) =>
//       Apicalls('post', '/user', data)
//       .then((res) => {
//         console.log('success');
//         //
//         dispatch({
//           type: userAdderss.login.success,
//           data: res.data
//         })
//         resolve(res)
//         .catch((err) => {
//           console.log('failure');
//           dispatch({
//             type: userAdderss.login.error,
//             data: err
//           });
//           reject(err);
//         });
//       })
//     );
// };

// export const AgentAddress = (data) => async (dispatch) => {
//   console.log("ag");
//   try {
//     // Replace the following line with your actual API request logic
//     const response = await fetch(`${url}/user`, {
//       method: 'POST',
//       headers: {
//         'Content-Type': 'application/json',
//       },
//       body: JSON.stringify(data),
//     });

//     const result = await response.json();

//     if (response.ok) {
//       console.log("success");
//       dispatch(agentAddressSuccess(result));
//     } else {
//       console.log("success");
//       dispatch(agentAddressFailure(result.error));
//     }
//   } catch (error) {
//     dispatch(agentAddressFailure('An error occurred while processing your request.'));
//   }
// }